export interface ExcavatorWithNearestLoading {
  bumperNumber: string;
  nearestLoading: { name: string } | null;
}

// loading point name -> bumper number of the excavator currently stationed there
export const buildLoadingLocationExcavatorMap = (
  excavators: ExcavatorWithNearestLoading[]
): Record<string, string> => {
  const map: Record<string, string> = {};
  excavators.forEach((exc) => {
    if (exc.nearestLoading?.name) {
      map[exc.nearestLoading.name] = exc.bumperNumber;
    }
  });
  return map;
};

// display an excavator's bumper number for a loading point it's parked at,
// location name otherwise — the underlying value sent to the API stays the location name
export const getAssignmentDisplayName = (
  locationName: string,
  loadingLocationExcavatorMap: Record<string, string>
): string => loadingLocationExcavatorMap[locationName] ?? locationName;
